import type { LayerState } from '@vitals/shared';
import type { VitalDef } from './vitals.js';

/**
 * Vital selector for the NYC Ferry layer.
 *
 * Display: value = ferry count / label "ferries".
 * Down/no-summary: value "—", label "ferries", down true.
 */
export const ferriesVital: VitalDef = {
  id: 'ferries',
  layerId: 'ferry',

  select(s: LayerState | undefined) {
    const down = !s || s.status === 'down';
    const stale = s?.status === 'stale';

    if (down || !s?.summary) {
      return { value: '—', label: 'ferries', down: true, stale };
    }

    const summary = s.summary as { count: number };
    const value = String(summary.count);

    return {
      value,
      label: 'ferries',
      down: false,
      stale,
    };
  },
};
